export default "__VITE_ASSET__COOLoJ2f__"